// @react
import React from 'react'
// @components
import DocumentTitle from 'react-document-title'
import PageWrapper from 'modules/activityHistory/components/PageWrapper'
import Content from 'modules/activityHistory/components/NetworkActivityContent'
import PageTitle from '@bit/atd.web.page-title'

/**
 * 4.0.3 My ATD - Activity History - Network Activity
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */

const title = 'Activity History - Network Activity'

const NetworkActivity = () => {
  /******************************************
   * RENDER
   ******************************************/

  return (
    <PageWrapper>
      <DocumentTitle title={`${title} | ATD`}>
        <>
          <PageTitle>Network Activity</PageTitle>
          <Content />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default NetworkActivity
